import i18n from "i18next";
import { initReactI18next } from 'react-i18next';
import {getCookie} from './functions/getCookie';
import deTranslations from './locales/de/translation.json';
import enTranslations from './locales/en/translation.json';
import nlTranslations from './locales/nl/translation.json';

const language = getCookie('language-britge')
const lang = language || 'nl'

const resources = {
  de: {
    translation: deTranslations,
  },
  en: {
    translation: enTranslations,
  },
  nl: {
    translation: nlTranslations,
  },
};

i18n
.use(initReactI18next)
.init({
  lng: lang,
  fallbackLng:'nl',
  resources,
  interpolation: {
    escapeValue: false 
  },
  debug: false,
  ns: ['translation'], // Default namespace
  defaultNS: 'translation',
  supportedLngs: Object.keys(resources), // List of supported languages
});

export default i18n;